import { ActivatedRoute } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Observable, combineLatest, BehaviorSubject } from 'rxjs';
import { PartnerUI } from '@app/shared/modules/evc-api/models/partner-ui.interface';
import { EvcApiService } from '@app/shared/modules/evc-api/services/evc-api.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerService implements OnDestroy {
  public readonly partner$: Observable<PartnerUI>;
  public readonly partners$: Observable<string[]>;
  public readonly restoredPartner$: Observable<PartnerUI>;

  protected readonly destroyed$: ReplaySubject<boolean>;
  protected readonly restoredPartnerSource$: BehaviorSubject<PartnerUI | null>;
  protected readonly partnerQueryParam = 'partner';
  protected readonly resellerCodeQueryParam = 'resellerCode';

  constructor(protected readonly route: ActivatedRoute, protected readonly evcApiService: EvcApiService) {
    this.destroyed$ = new ReplaySubject();
    this.restoredPartnerSource$ = new BehaviorSubject(null);
    this.restoredPartner$ = this.restoredPartnerSource$.asObservable();

    this.partners$ = this.evcApiService.getCarBrands().pipe(
      map((cars) => {
        if (!cars) {
          return [];
        }

        return cars.map((car) => car.name.toLowerCase());
      }),
      takeUntil(this.destroyed$)
    );

    const queryPartner$ = this.route.queryParamMap.pipe(
      map((params) => params.get(this.partnerQueryParam)),
      shareReplay(),
      takeUntil(this.destroyed$)
    );

    const queryresellerCodeQueryParam$ = this.route.queryParamMap.pipe(
      map((params) => params.get(this.resellerCodeQueryParam)),
      shareReplay(),
      takeUntil(this.destroyed$)
    );

    this.partner$ = combineLatest([queryPartner$, queryresellerCodeQueryParam$, this.partners$]).pipe(
      map(([partner, resellerCode, partners]) => {
        if (!partners.includes(partner)) {
          return null;
        }

        const partnerUI: PartnerUI = { name: partner, resellerCode, path: `./assets/img/${partner}.png` };

        this.restoredPartnerSource$.next(partnerUI);

        return partnerUI;
      }),
      takeUntil(this.destroyed$)
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
